import Vue from 'vue';
import {
  HTTP
} from '@/http';

export default class RegisterService {
  register(data, isDemo) {
    let url = `register/`;
    if (isDemo) {
      url += `demo`;
    } else {
      url += `live`;
    }
    return HTTP.post(url, data);
  }
}



// WEBPACK FOOTER //
// ./src/services/RegisterService.js